import React, { useEffect, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Grid, GridItem } from '../../grid/Grid.jsx'
import { constants } from './constants.js'
import { isScreenSmall } from '../../../utility/index.js'
import {
  getLink,
  getLinkFromRef,
} from '../../../utility/index.js'
import { BrManageContentButton } from '@bloomreach/react-sdk'
import './heroBanner.css'
import ButtonLinkCtaList from '../../link/buttonLinkCtaList.jsx'
import DOMPurify from 'dompurify'

const BannerConnect = ({ page, component }) => {
  // process page and compoenent parameters here and pass the to Banner
  const _models = component.getModels()
  const { document: _documentRef } = _models
  const document = _documentRef && page.getContent(_documentRef)
  const data = document?.getData() || {}
  const imageUrl = page.getContent(data?.image?.$ref)?.getOriginal()?.getUrl()
  const mobileImageUrl = page
    .getContent(data?.mobileImage?.image?.$ref)
    ?.getOriginal()
    ?.getUrl()
  const bgImageUrl = page
    .getContent(data?.bgImage?.image?.$ref)
    ?.getOriginal()
    ?.getUrl()
  const params = component?.getParameters()


  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    const mediaQuery = matchMedia('(max-width: 768px)')
    setIsMobile(mediaQuery.matches)
    const handleChange = (event) => setIsMobile(event.matches)
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])


  const {
    eyebrowFont,
    secondaryHeadingColor,
    eyebrowColor,
    angleBorder,
    angleType,
    backgroundColor,
    gridSize,
    columnCount,
    textColor,
    verticalPadding,
    verticalMargin,
    angleBorderColor,
    width,
    contentAlignment,
  } = params

  const componentProps = {
    angleBorder,
    angleBorderColor,
    angleType,
    backgroundColor,
    columnCount,
    eyebrowColor,
    gridSize,
    secondaryHeadingColor,
    textColor,
    verticalPadding,
    verticalMargin,
    width,
    contentAlignment,
  }
  const documentProps = {
    bgImageUrl: bgImageUrl,
    eyebrowFont: eyebrowFont,
    eyebrowText: data?.eyebrowText,
    imageUrl: imageUrl,
    mobileImageUrl: mobileImageUrl,
    primaryHeading:
      data?.title && typeof data?.title === 'object'
        ? data?.title?.value
        : data?.title || '',
    secondaryHeading: data?.subtitle,
    linkList: data?.links
      ?.filter((l) => l.link && l.link.length > 0)
      ?.map((l) => getLink(getLinkFromRef(l, page), null)),
  }

  const args = {
    ...componentProps,
    ...documentProps,
    isMobile: isMobile,
  }
  return (
    <div className="heroBanner u-posRelative">
      {document && <BrManageContentButton content={document} />}
      <HeroBanner {...args} />
    </div>
  )
}

export const HeroBanner = ({
  backgroundColor = 'dark',
  imageUrl = '',
  bgImageUrl = '',
  mobileImageUrl = '',
  gridSize = 3,
  columnCount = 2,
  textColor = 'white',
  primaryHeading = '',
  secondaryHeading = '',
  secondaryHeadingColor = 'inherit',
  eyebrowColor = 'white',
  eyebrowText = '',
  eyebrowFont = 'Publico',
  verticalPadding = 8,
  verticalMargin = 0,
  angleType = 'content',
  angleBorder = 'double',
  linkList = [],
  angleBorderColor = 'white',
  width = 'full',
  contentAlignment = '',
  isMobile = false,
}) => {
  const bgClass = constants.backgroundColors[backgroundColor] || ''
  const textColorClass =
    textColor === 'black' ? 'u-textColorBlack' : 'u-textColorWhite'
  const eyebrowFontClass = eyebrowFont === 'Roboto' ? 'roboto-font' : ''
  const eyebrowColorClass = constants.textColors[eyebrowColor]
  const widthClass = width === 'inset' ? 'u-sizeConstrained' : 'u-sizeFull'
  const contentAlignmentClass =
    contentAlignment === 'center' ? 'u-flexAlignItemsCenter' : ''
  return (
    <div
      className={`Banner u-posRelative u-marginVert${verticalMargin}gu u-overflowHidden ${widthClass}`}
    >
      {imageUrl && (
        <div
          id="bannerImage"
          style={{
            backgroundImage: `url("${isMobile ? mobileImageUrl || imageUrl : imageUrl}")`,
          }}
        ></div>
      )}
      <div
        id="bannerCutout"
        className={`${angleBorder} ${angleType} ${angleBorderColor}`}
      >
        {bgImageUrl ? (
          <div
            className={`Background ${bgClass} ${angleType}`}
            style={{
              backgroundImage: `url("${bgImageUrl}")`,
            }}
          ></div>
        ) : (
          <div className={`Background ${bgClass} ${angleType}`}></div>
        )}
      </div>
      <div className="content u-posRelative u-paddingHoriz12gu u-sm-paddingHoriz4gu ">
        <Grid>
          <GridItem
            className={`u-paddingVert${verticalPadding}gu u-flex u-flexCol  ${contentAlignmentClass} u-flexJustifyCenter u-md-size2of3 u-sm-sizeFull ${textColorClass}`}
            columnCount={columnCount}
            gridSize={gridSize}
          >
            {eyebrowText && (
              <div
                className={`eyebrow u-textSizeMsrp1 ${eyebrowFontClass} ${eyebrowColorClass}`}
              >
                {eyebrowText}
              </div>
            )}
            {primaryHeading && (
              <div
                className="primaryHeading"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(primaryHeading),
                }}
              />
            )}
            {secondaryHeading && (
              <div
                className={`secondaryHeading u-textSizeMsrp2 u-paddingTop4gu ${secondaryHeadingColor}`}
              >
                {secondaryHeading}
              </div>
            )}

            {linkList && linkList.length > 0 && (
              <div className="u-marginTop6gu">
                <ButtonLinkCtaList linkList={linkList} />
              </div>
            )}
          </GridItem>
        </Grid>
      </div>
    </div>
  )
}

function BannerErrorBoundary(props) {
  return (
    <ErrorBoundary
      fallback={<div></div>}
      onError={(error, info) => {
        console.log('BannerErrorBoundary error:', error, info)
      }}
    >
      <BannerConnect {...props}></BannerConnect>
    </ErrorBoundary >
  )
}

export default BannerErrorBoundary
